import type { IntlShape } from 'react-intl';

import { isServiceOrder, type OrderSummary } from '#domain/Order.ts';
import { isCanonicalServiceType, parseServiceOrderStopName } from '#domain/serviceOrderStopName.ts';
import { filterStopInSearch } from '#utils/searchUtils.ts';

export const containsOrderSearchTerm = (
    item: OrderSummary,
    search: string,
    intl?: Pick<IntlShape, 'formatMessage'>
) => {
    const text = search.trim().toLowerCase();
    const serviceType = isServiceOrder(item) ? parseServiceOrderStopName(item.number).serviceType : undefined;
    const localizedServiceType =
        serviceType && isCanonicalServiceType(serviceType)
            ? intl?.formatMessage({
                  id: `intl-msg:ordercom-cloud-frontend.service.type.${serviceType}`,
                  defaultMessage: serviceType,
              })
            : undefined;
    return (
        localizedServiceType?.toLowerCase().includes(text) ||
        item.number?.toLowerCase().includes(text) ||
        item.customerName?.toLowerCase().includes(text) ||
        item.tourName?.toLowerCase().includes(text) ||
        item.truck?.name?.toLowerCase().includes(text) ||
        (isServiceOrder(item)
            ? item.description.toLowerCase().includes(text) || filterStopInSearch(text, item.executionStop)
            : filterStopInSearch(text, item.loadingStop) || filterStopInSearch(text, item.unloadingStop))
    );
};
